import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc1026',
    ecrans: ['00-2']
});